import { render, staticRenderFns } from "./LoginDecider.vue?vue&type=template&id=cd65d15e"
import script from "./LoginDecider.vue?vue&type=script&lang=ts"
export * from "./LoginDecider.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports